<template>
  <div>
    <v-card-title class="text-primary text-left"
      >Total de clientes: {{ items.meta.total }} clientes</v-card-title
    >
    <v-data-table
      class="elevation-2 text-black table__desing-general bordered-table main-table"
      fixed-header
      :items="items.data"
      :loading="loading"
      :headers="headers"
      hide-default-header
      :items-per-page="items.meta.per_page"
      :page="items.meta.current_page"
      :server-items-length="items.meta.total"
      @update:page="onPageChange"
      @update:items-per-page="onItemsPerPageChange"
    >
      <template #header>
        <thead class="header-table gray-header">
          <tr>
            <th
              v-for="(item, index) in headers"
              :key="index"
              :colspan="item?.colspan || 0"
              class="pa-4 text-subtitle-2 text-black text-center font-weight-bold"
            >
              {{ item.text }}
            </th>
          </tr>
        </thead>
      </template>

      <template #[`item.name`]="{ item }">
        <v-tooltip bottom>
          <template #[`activator`]="{ on, attrs }">
            <span
              class="text-black font-weight-bold text-decoration-underline text-nowrap cursor-pointer"
              v-bind="attrs"
              @click="showCustomer(item.id)"
              v-on="on"
              >{{ textTruncate(item.name) }}</span
            >
          </template>
          <span>{{ item.name }}</span>
        </v-tooltip>
      </template>
      <template #[`item.address.street`]="{ item }">
        <v-tooltip bottom>
          <template #[`activator`]="{ on, attrs }">
            <span class="text-nowrap" v-bind="attrs" v-on="on">{{
              textTruncate(item.address.street)
            }}</span>
          </template>
          <span>{{ item.address.street }}</span>
        </v-tooltip>
      </template>
      <template #[`item.address.neighborhood`]="{ item }">
        <v-tooltip bottom>
          <template #[`activator`]="{ on, attrs }">
            <span class="text-nowrap" v-bind="attrs" v-on="on">{{
              textTruncate(item.address.neighborhood)
            }}</span>
          </template>
          <span>{{ item.address.neighborhood }}</span>
        </v-tooltip>
      </template>
      <template #[`item.address.municipality`]="{ item }">
        <v-tooltip bottom>
          <template #[`activator`]="{ on, attrs }">
            <span class="text-nowrap" v-bind="attrs" v-on="on">{{
              textTruncate(item.address.municipality)
            }}</span>
          </template>
          <span>{{ item.address.municipality }}</span>
        </v-tooltip>
      </template>
      <template #[`item.address.state`]="{ item }">
        <span class="text-nowrap">{{ item.address.state }}</span>
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="text-nowrap">
          <v-tooltip bottom>
            <template #[`activator`]="{ on, attrs }">
              <v-btn icon @click="showCustomer(item.id)">
                <v-icon size="27" color="orange" v-bind="attrs" v-on="on"
                  >mdi-truck-delivery-outline</v-icon
                >
              </v-btn>
            </template>
            <span>Domicilios de entrega</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template #[`activator`]="{ on, attrs }">
              <v-btn icon @click="showCustomerContacts(item)">
                <v-icon size="27" color="primary" v-bind="attrs" v-on="on"
                  >mdi-card-account-details-outline</v-icon
                >
              </v-btn>
            </template>
            <span>Contactos de cliente</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import helpers from '@/mixins/helpers';

  export default {
    name: 'CustomersList',
    mixins: [helpers],
    props: {
      items: {
        type: Object,
        default: () => ({
          data: [],
          meta: [],
        }),
        required: true,
      },
      loading: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        headers: [
          {
            text: 'Número',
            value: 'id',
          },
          {
            text: 'Nombre',
            value: 'name',
          },
          {
            text: 'Canal',
            value: 'channel',
          },
          {
            text: 'Calle y número',
            value: 'address.street',
          },
          {
            text: 'Colonia',
            value: 'address.neighborhood',
          },
          {
            text: 'Municipio',
            value: 'address.municipality',
          },
          {
            text: 'Estado',
            value: 'address.state',
          },
          {
            text: 'CP',
            value: 'address.postal_code',
          },
          {
            text: 'Acciones',
            value: 'actions',
          },
        ],
      };
    },
    methods: {
      showCustomer(code) {
        this.$emit('onCustomerClick', code);
      },
      onPageChange(page) {
        this.$emit('onTableChange', page, this.items.meta.per_page);
      },
      onItemsPerPageChange(perPage) {
        this.$emit('onTableChange', this.items.meta.current_page, perPage);
      },
      showCustomerContacts(customerInfo) {
        this.$emit('onCustomerContactsClick', customerInfo);
      },
    },
  };
</script>
<style scoped src="@/assets/css/table.css"></style>
